import Vue from 'vue';
import VueI18n from 'vue-i18n'
import VueRouter from 'vue-router';
import ElementUI from 'element-ui';
import Vuetify from 'vuetify'
import 'element-ui/lib/theme-chalk/index.css';

//import UploaderPlugin  from '@syncfusion/ej2-vue-inputs';
import locale from 'element-ui/lib/locale/lang/en'
import BlockUIService from './Shared/BlockUIService.js';

import App from './App.vue';
import Layout from './components/Layout/Layout.vue';
import Login from './components/Login/Login.vue';
import Home from './components/Home/Home.vue';
import DataService from './Shared/DataService';
import Helper from './Shared/Helper';

import VueEllipseProgress from 'vue-ellipse-progress';



//Financial
import Subscriptions from './components/Financial/Subscriptions/Subscriptions.vue';
import Financial from './components/Financial/Financial.vue';


//Dictionaries
import Cities from './components/Dictionaries/Cities/Cities.vue';
import Municipalities from './components/Dictionaries/Municipalities/Municipalities.vue';
import FertilizationCompanies from './components/Dictionaries/FertilizationCompanies/FertilizationCompanies.vue';
import Fertilization from './components/Dictionaries/Fertilization/Fertilization.vue';
import PalmsType from './components/Dictionaries/PalmsType/PalmsType.vue';
import PalmsCareType from './components/Dictionaries/PalmsCareType/PalmsCareType.vue';
import PestsCompanies from './components/Dictionaries/PestsCompanies/PestsCompanies.vue';
import Pests from './components/Dictionaries/Pests/Pests.vue';
import Classification from './components/Dictionaries/Classification/Classification.vue';
import PesticidesCompanies from './components/Dictionaries/PesticidesCompanies/PesticidesCompanies.vue';
import Pesticides from './components/Dictionaries/Pesticides/Pesticides.vue';
import SubscriptionsTypes from './components/Dictionaries/SubscriptionsTypes/SubscriptionsTypes.vue';


//Farm
import Farmes from './components/Farmes/Farmes.vue';
import MyFarmes from './components/Farmes/MyFarmes/MyFarmes.vue';
import SoilAnalysis from './components/Farmes/SoilAnalysis/SoilAnalysis.vue';
import WaterAnalysis from './components/Farmes/WaterAnalysis/WaterAnalysis.vue';
import Groups from './components/Farmes/Groups/Groups.vue';
import Power from './components/Farmes/Power/Power.vue';


//Palms
import Palms from './components/Palms/Palms.vue';
import PalmsFertilization from './components/Palms/Fertilization/Fertilization.vue';
import PalmsPests from './components/Palms/Pests/Pests.vue';
import PalmsCare from './components/Palms/Care/Care.vue';
import PalmsPreventiveOperations from './components/Palms/PreventiveOperations/PreventiveOperations.vue';
import PalmsProduction from './components/Palms/Production/Production.vue';
import PalmsSeedlings from './components/Palms/Seedlings/Seedlings.vue';


//Users
import Users from './components/Users/Users.vue';
import UsersProfile from './components/Users/Profile/Profile.vue';




Vue.use(VueEllipseProgress);

Vue.use(Vuetify)
Vue.use(VueI18n);
Vue.use(VueRouter);
//Vue.use(UploaderPlugin);
Vue.use(ElementUI, { locale });

Vue.config.productionTip = false;

Vue.prototype.$http = DataService;
Vue.prototype.$blockUI = BlockUIService;
Vue.prototype.$helper = Helper;


export const eventBus = new Vue();


const router = new VueRouter({
    mode: 'history',
    base: __dirname,
    linkActiveClass: 'active',
    routes: [
        {
            path: '/Login',
            component: Login,
         
        },
         {
            path: '/',
            component: App,
            children: [
                {
                    path: '',
                    component: Layout,
                    children: [
                        { path: '', component: Home },

                        //Financial
                        { path: 'Financial', component: Financial },
                        { path: 'Subscriptions', component: Subscriptions },

                        //Dictionaries
                        { path: 'Cities', component: Cities },
                        { path: 'Municipalities', component: Municipalities },
                        { path: 'FertilizationCompanies', component: FertilizationCompanies },
                        { path: 'Fertilization', component: Fertilization },
                        { path: 'PalmsType', component: PalmsType },
                        { path: 'PalmsCareType', component: PalmsCareType },
                        { path: 'PestsCompanies', component: PestsCompanies },
                        { path: 'Pests', component: Pests },
                        { path: 'Classification', component: Classification },
                        { path: 'PesticidesCompanies', component: PesticidesCompanies },
                        { path: 'Pesticides', component: Pesticides },
                        { path: 'SubscriptionsTypes', component: SubscriptionsTypes },

                        //Farmes
                        { path: 'Farmes', component: Farmes },
                        { path: 'MyFarmes', component: MyFarmes },
                        { path: 'SoilAnalysis', component: SoilAnalysis },
                        { path: 'WaterAnalysis', component: WaterAnalysis },
                        { path: 'Groups', component: Groups },
                        { path: 'Power', component: Power },

                        //Palms
                        { path: 'Palms', component: Palms },
                        { path: 'PalmsFertilization', component: PalmsFertilization },
                        { path: 'PalmsPests', component: PalmsPests },
                        { path: 'PalmsCare', component: PalmsCare },
                        { path: 'PalmsPreventiveOperations', component: PalmsPreventiveOperations },
                        { path: 'PalmsProduction', component: PalmsProduction },
                        { path: 'PalmsSeedlings', component: PalmsSeedlings },

                        //Users
                        { path: 'Users', component: Users },
                        { path: 'UsersProfile', component: UsersProfile },


                       
                       
                    ]
                },
            ],
        }
    ]
});

Vue.filter('toUpperCase', function (value) {
    if (!value) return '';
    return value.toUpperCase();
});

new Vue({
    router,
    render: h => {
        return h(App);
    }
}).$mount('#cpanel-management');
